import apiClient from './client';

export interface BlockedDate {
  id: number;
  professional: number;
  date: string;
  block_type: 'full_day' | 'time_range';
  block_type_display: string;
  start_time: string | null;
  end_time: string | null;
  reason: string;
  created_at: string;
}

export interface BlockedDateCreateRequest {
  date: string;
  block_type: 'full_day' | 'time_range';
  start_time?: string;
  end_time?: string;
  reason?: string;
}

export interface PaginatedBlockedDates {
  count: number;
  next: string | null;
  previous: string | null;
  results: BlockedDate[];
}

/**
 * Blocked Dates API Service
 */
export const blockedDatesAPI = {
  /**
   * Get all blocked dates for the authenticated professional
   */
  getAll: () =>
    apiClient.get<PaginatedBlockedDates>('/blocked-dates/'),

  /**
   * Get blocked dates by month
   */
  getByMonth: (year: number, month: number) =>
    apiClient.get<BlockedDate[]>('/blocked-dates/by_month/', { params: { year, month } }),

  /**
   * Get blocked dates for a specific professional (public access for availability checking)
   */
  getByProfessional: (professionalId: number) =>
    apiClient.get<PaginatedBlockedDates>('/blocked-dates/', { params: { professional: professionalId } }),

  /**
   * Get blocked date by ID
   */
  getById: (id: number) =>
    apiClient.get<BlockedDate>(`/blocked-dates/${id}/`),

  /**
   * Create a new blocked date
   */
  create: (data: BlockedDateCreateRequest) =>
    apiClient.post<BlockedDate>('/blocked-dates/', data),

  /**
   * Update blocked date
   */
  update: (id: number, data: Partial<BlockedDateCreateRequest>) =>
    apiClient.patch<BlockedDate>(`/blocked-dates/${id}/`, data),

  /**
   * Delete blocked date
   */
  delete: (id: number) =>
    apiClient.delete(`/blocked-dates/${id}/`),
};
